const DEFAULT_CULTURE = 'da-dk';

// Fall back to da-dk if culture has no country code (ex.: "da").
export const normalizeCulture = (culture?: string | null) =>
    culture && /^[a-z]{2}-[a-z]{2}$/i.test(culture) ? culture : DEFAULT_CULTURE;
